export const BACKEND_URL = 'https://backend.agrippa.build/';
